import { BrowserRouter, Routes, Route } from "react-router-dom";

import PhoneScreen from './components/PhoneScreen';
import Content from './components/Content';
import NewSkin from './components/NewSkin';

import './App.css';


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <PhoneScreen>
        <Routes>
          <Route path="/" element={<Content />} />
          <Route path="skin/:color" element={<NewSkin />} />
        </Routes>
        </PhoneScreen>
      </div>
    </BrowserRouter>
  );
}

export default App;
